import JSZip from 'jszip';
import Param from '../store/param';
import Control from '../store/control';
import { SavePLY, SaveSTL } from '../fileIO/fileExporter';

export function Download(blob, filename) {
  console.log("Save", filename);

  var link = document.createElement('a');
  link.style.display = 'none';
  document.body.appendChild(link);

  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
}


function createZip(param, meshLeg) {
  var zip = new JSZip();
  var folder = 'param/';
  //zip.file(folder + "param.json", param);
  zip.file('param.json', param)
  if (meshLeg) {
    const fileLeg = SavePLY(meshLeg);
    zip.file('leg_align.ply', fileLeg)
  }
  //console.log('zip:', folder + "param.json");

  /*
  console.log("post: /api/zip");
  var vtp = postSync("/api/zip");
  if(vtp){
    zip.file(folder + "vtp.zip", vtp);
    console.log('zip:', folder + "vtp.zip");
  }

  if( meshLeg ){
    const fileLeg = SavePLY(meshLeg);
    zip.file(folder + "leg.ply", fileLeg);
    console.log('zip:', folder + "leg.ply");
  }
  if( meshSocketF10 ){
    const fileSocket = SaveSTL(meshSocketF10);
    zip.file(folder + "socketF10.stl", fileSocket);
    console.log('zip:', folder + "socketF10.stl");
  }
  if( meshSocketF11 ){
    const fileSocket = SaveSTL(meshSocketF11);
    zip.file(folder + "socketF11.stl", fileSocket);
    console.log('zip:', folder + "socketF11.stl");
  }
  if( meshSocketF14 ){
    const fileSocket = SaveSTL(meshSocketF14);
    zip.file(folder + "socketF14.stl", fileSocket);
    console.log('zip:', folder + "socketF14.stl");
  }
  if( meshSocketF16 ){
    const fileSocket = SaveSTL(meshSocketF16);
    zip.file(folder + "socketF16.stl", fileSocket);
    console.log('zip:', folder + "socketF16.stl");
  }
  if( meshSocketF17 ){
    const fileSocket = SaveSTL(meshSocketF17);
    zip.file(folder + "socket.stl", fileSocket);
    console.log('zip:', folder + "socket.stl");
  }
  if( meshSocketF26 ){
    const fileSocket = SaveSTL(meshSocketF26);
    zip.file(folder + "socketF26.stl", fileSocket);
    console.log('zip:', folder + "socketF26.stl");
  }
  if( meshFinal ){
    const fileFinal = SaveSTL(meshFinal);
    zip.file(folder + "final.stl", fileFinal);
    console.log('zip:', folder + "final.stl");
  }
  */
  return zip;
}

export const onSaveLocal = (param, meshLeg=null) => {
  var zip = createZip(param, meshLeg);
  zip.generateAsync({ type: "blob" })
    .then(function (content) {
      Download(content, "param.zip")
    });
}

/*  
const FileSave = () => {
  const style         = SideStyle();
  const paramJson     = Param.ToBlob();
  const type          = Control.Get("type");
  const meshLeg       = Control.Get("meshLeg");
  const meshSocketF10 = Control.Get("meshSocketF10");
  const meshSocketF11 = Control.Get("meshSocketF11");
  const meshSocketF14 = Control.Get("meshSocketF14");
  const meshSocketF16 = Control.Get("meshSocketF16");
  const meshSocketF17 = Control.Get("meshSocketF17");
  const meshSocketF26 = Control.Get("meshSocketF26");
  const meshFinal     = Control.Get("meshFinal");
  const patient_no    = Param.Get("patient_no")
  const diagnosis_no  = Param.Get("diagnosis_no")
  const device_no     = Param.Get("device_no")
  const activeStep    = Param.Get("activeStep");

  function createZip(){
    var zip = new JSZip();
    var folder = patient_no + "/" + diagnosis_no + "/" + type + "/" + device_no + "/";
    zip.file(folder + "param.json", paramJson);
    console.log('zip:', folder + "param.json");

    console.log("post: /api/zip");
    var vtp = postSync("/api/zip");
    if(vtp){
      zip.file(folder + "vtp.zip", vtp);
      console.log('zip:', folder + "vtp.zip");
    }

    if( meshLeg ){
      const fileLeg = SavePLY(meshLeg);
      zip.file(folder + "leg.ply", fileLeg);
      console.log('zip:', folder + "leg.ply");
    }
    if( meshSocketF10 ){
      const fileSocket = SaveSTL(meshSocketF10);
      zip.file(folder + "socketF10.stl", fileSocket);
      console.log('zip:', folder + "socketF10.stl");
    }
    if( meshSocketF11 ){
      const fileSocket = SaveSTL(meshSocketF11);
      zip.file(folder + "socketF11.stl", fileSocket);
      console.log('zip:', folder + "socketF11.stl");
    }
    if( meshSocketF14 ){
      const fileSocket = SaveSTL(meshSocketF14);
      zip.file(folder + "socketF14.stl", fileSocket);
      console.log('zip:', folder + "socketF14.stl");
    }
    if( meshSocketF16 ){
      const fileSocket = SaveSTL(meshSocketF16);
      zip.file(folder + "socketF16.stl", fileSocket);
      console.log('zip:', folder + "socketF16.stl");
    }
    if( meshSocketF17 ){
      const fileSocket = SaveSTL(meshSocketF17);
      zip.file(folder + "socket.stl", fileSocket);
      console.log('zip:', folder + "socket.stl");
    }
    if( meshSocketF26 ){
      const fileSocket = SaveSTL(meshSocketF26);
      zip.file(folder + "socketF26.stl", fileSocket);
      console.log('zip:', folder + "socketF26.stl");
    }
    if( meshFinal ){
      const fileFinal = SaveSTL(meshFinal);
      zip.file(folder + "final.stl", fileFinal);
      console.log('zip:', folder + "final.stl");
    }
    return zip;
  }

  const onSaveLocal = () => {
    var zip = createZip();
    zip.generateAsync({type:"blob"})
    .then(function(content) {
      Download(content, patient_no + ".zip")
    });
  }

  const onSaveCloud = () => {
    const filename = "patientdata/" + patient_no + "/" + diagnosis_no + "/" + type + "/" + device_no + "/crus.zip";
    console.log('filename:', filename);
    var s3 = new AWS.S3();
    var zip = createZip();
    zip.generateAsync({type:"blob"})
    .then(function(content) {
      const params = {Bucket: AWS_BUCKET_NAME, Key: filename, Body: content};
      s3.upload(params, function (err, data) {
        if (err) {
          console.log(err, err.stack);
        }
        if (data) {
          console.log("Upload Success", data.Location);
        }
      })
    });
  }

  function getDisabled(){
    return ((activeStep >= 1) && (patient_no != "")) ? false : true;
  }

  return (
    <Grid container direction="row" spacing={1}>
      <Grid item xs={6}>
        <Button className={style.button} onClick={onSaveLocal} disabled={getDisabled()}>Save Local</Button>
      </Grid>
      <Grid item xs={6}>
        <Button className={style.button} onClick={onSaveCloud} disabled={getDisabled()}>Save Cloud</Button>
      </Grid>
    </Grid>
  );
}
export default FileSave;
*/